var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SelectField',{attrs:{"label":_vm.label,"selected":_vm.selected,"remote":true,"filterable":true,"placeholder":'Type to search documents',"loading":_vm.loading,"remoteMethod":_vm.remoteMethod,"options":_vm.options,"multiple":true},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }